( function( $, document ) {
    'use strict';

    $( function() {
	    var activeClass = 'is-active';
	    var animationDuration = 400;
	    var $searchTrigger = $( '.js-site-header-search-trigger' );
	    var $search = $( '.js-site-header-search' );
	    var $searchField = $( '.js-site-header-search-field' );

	    $searchTrigger.on( 'click', function( event ) {
		    event.preventDefault();

		    $search.animate( {
			    'width': 'toggle'
		    }, animationDuration, function() {
			    $( this ).toggleClass( activeClass );
			    $searchField.focus();

			    $( document ).on( 'mouseup.qrc.site-header-search touchend.qrc.site-header-search', function( event ) {
				    if ( ! $search.is( event.target ) && 0 === $search.has( event.target ).length ) {
					    $search.animate( {
						    'width': 'toggle'
					    }, animationDuration, function() {
						    $( this ).toggleClass( activeClass );
						    $searchField.blur();
						    $( document ).off( 'mouseup.qrc.site-header-search touchend.qrc.site-header-search' );
					    } );
				    }
			    } );
		    } );
	    } );
    } );
} )( jQuery, document );
